export const BASE_API = {
  // Auth -(Account Management)
  login: "/user/login",

  // Geo Info -(GEO Setup)
  createRegion: "/geo/create-region",
  updateRegion: "/geo/update-region-by",
  getAllRegion: "/geo/get-regions",
  getSingleRegion: "/geo/get-region-by",
  getCountRegion: "/geo/count-regions",
  getMe: "/user/get-me?isWeb=true",
  addMobileToken: "/user/update-mobile-token",

  createArea: "/geo/create-area",
  updateArea: "/geo/update-area-by",
  getAllArea: "/geo/get-areas",
  getSingleArea: "/geo/get-area-by",
  getCountArea: "/geo/counts-area",

  createTerritory: "/geo/create-teritory",
  updateTerritory: "/geo/update-teritory-by",
  getAllTerritory: "/geo/get-teritorys",
  getSingleTerritory: "/geo/get-teritory-by",
  getCountTerritory: "/geo/counts-teritory",

  // Resource -(User)
  checkEmail: "/user/check-email",
  checkEmployeeID: "/user/check-employeeId",
  checkPhone: "/user/check-phone",
  checkNID: "/user/check-nid",
  createUser: "/user/create-user",
  getAllUsers: "/user/get-users",
  getCountUsers: "/user/counts-user",
  userUpdatePassword: "/user/update-password",

  // Network -(Tower Management)
  checkTowerName: "/tower/check-tower-name",
  checkSiteCode: "/tower/check-site-code",

  createTower: "/tower/create-tower",
  getAllTower: "/tower/get-towers",
  getAllTower2: "/tower/get-tower-more-filter",
  getCountTower: "/tower/counts-tower",
  getCountTower2: "/tower/get-tower-count-more-filter",
  getSingleTicket: "/tower/get-tower-by",
  bulkUploadTower: "/tower/tower-bulk-upload",
  updateTower: "/tower/edit-tower",
  towerBulkMail: "/tower/get-bulk-mail",
  removePGFromTowerTicket: "/tower/pg-remove-from-last-tt",
  towerTicketCancel: "/tower/ticket-cancel",
  towerTicketStart: "/tower/pg-manual-start-alarm",
  towerTicketStop: "/tower/pg-manual-off-alarm",
  getCalculationWorkTime: "/tower/calculate-times",
  getSingleTowerlog: "/tower/get-single-towers-log",

  createTowerTicket: "/tower/create-ticket",
  towerTicketNotification: "/tower/send-notification-to-related-pg",
  sendFeedback: "/tower/admin-give-feedback",
  networkLogView: "/tower/get-single-tower-log",

  // Supplier
  createSupplier: "/user/create-supplier",
  updateSupplier: "/user/supplier-user/update",
  getAllSupplier: "/user/get-suppliers",
  getCountSupplier: "/user/supplier/counts-suppliers",
  getSupplierUser: "/user/get-user-by-supplier",
  getCountUserSupplier: "/user/get-number-of-user-by-supplier",
  getSupplierProfile: "/user/get-suppler-profile",
  getSingleSupplier: "/user/get-supplier",
  bulkCreatePO: "/po/v1/bulk-create",
  createPO: "/po/v1/create",
  getAllPO: "/po/v1/get-all",
  getSinglePO: "/po/v1/get-one",
  updatePO: "/po/v1/inc-remaining-balance",
  createBatchPayment: "/batch-payment/v1/create",
  updateBatchPayment: "/batch-payment/v1/update",
  getCompletedTowerBySupplier: "/batch-payment/v1/completed-tower-by-supplier",
  getAllBatchmentPayment: "/batch-payment/v1/disbursement-all",
  getSingleBatchmentPayment: "/batch-payment/v1/disbursement",
  forwardRequestToStepAbove: "/batch-payment/v1/forward",
  markPaidPayment: "/batch-payment/v1/mark-paid",
  rejectBatchPayment: "/batch-payment/v1/reject",
  getAllTowersByBatchPaymentId: "/batch-payment/v1/tower-tickets",
  generateInvoice: "/batch-payment/v1/vendor-details",
  getSinglePOForVendor: "/po/v1/latest-po",
  addBatchTask: "/batch-payment/v1/process",
  getGeneratePdf: "/batch-payment/v1/generate-pdf",
  irExcelUpload: "/batch-payment/v1/add-bulk-ir-data",

  // Dashboard
  getActiveAndInactiveTower: "/tower/get-active-inactive-numer-of-tower",
  getActiveAndInactiveMap: "/tower/get-active-inactvie-route-for-map",
  getDashboardLog: "/tower/get-dashboard-log",

  // Payment
  getAllPayment: "/tower/getdataforpayment",
  getCountPayment: "/tower/countdataforpayment",
  getTotalAmount: "/tower/totalAmount",
  getUnpaidClick: "/tower/wallet-transaction/payment",
  updateStatus: "/tower/updateCheckStatus",
  getFinanceBalance: "/user/finance/remaining-balance",

  // Image -(File Upload)
  fileUpload: `/tower/upload-image`,

  // Price Matrix
  bulkCreatePriceMatrix: "/api/price-matrix/bulk",
  getAllPriceMatrix: "/api/price-matrix",
  getSinglePriceMatrix: "/api/price-matrix",
  getAllPriceMatrixLogs: "/api/price-matrix/logs",
  updatePriceMatrix: "/api/price-matrix",
};
